module.exports = __webpack_public_path__ + "static/media/aceptacion-tarjeta.0f3a7908.svg";